import React, { Component } from 'react'
import { connect } from 'react-redux'
import { reduxForm, Field, formValueSelector } from 'redux-form'
import { SelectField, RadiobuttonGroup } from '../../components/inputs'
import { fetchAllVehicles } from './vehiclesActions'
import {
  selectAllVehicleMakes,
  selectAllVehicleModels,
} from '../../reducers/vehicles'
import { AccessibleOrganizationsSelect } from '../../components/inputs/accessibleOrganizationsSelect'
import LoaderButton from '../../components/loaderButton'
import { ReduxFormProps } from '../../forms'

export type Callback<T = void> = (...args: any) => T

export interface Props {
  allMakes: string[]
  cancel: Callback
  clear: Callback
  clearFields?: Callback
  fetchAllVehicles: Callback
  fetchModels: Callback
  makesData: object
  renderYears: Callback
  vehicleMakes: { models: string[] }
  vehicleMeta: object
}

export class VehicleFilterForm extends Component<
  ReduxFormProps<Props, object>
> {
  static displayName = 'VehicleFilterForm'

  componentWillMount() {
    this.props.fetchAllVehicles()
  }

  renderModels = () => {
    const { makesData, fetchModels } = this.props
    makesData ? fetchModels(makesData) : (e) => fetchModels(e.target.value)
  }

  render() {
    const {
      handleSubmit,
      submitting,
      clear,
      cancel,
      vehicleMakes,
      makesData,
      renderYears,
      allMakes,
    } = this.props

    return (
      <form
        className="form index-filter__form"
        name="VehicleFilterForm"
        onSubmit={handleSubmit}
      >
        <div
          className="vehicle-filter"
          // disabled={submitting} // TODO-TS
        >
          <div>
            <h2 className="filter__header">Year</h2>
            <hr className="form__hr vehicle-filter__hr" />
            <Field
              label="Select a year"
              name="year"
              component={SelectField}
              gridClass="field vehicle-filter__field"
            >
              <option value="" />
              {renderYears()}
            </Field>
          </div>
          <div>
            <h2 className="filter__header">Make</h2>
            <hr className="form__hr vehicle-filter__hr" />
            <Field
              label="Select a make"
              name="make"
              component={SelectField}
              gridClass="field vehicle-filter__field"
              onChange={this.renderModels}
            >
              <option value="" />
              {allMakes ? (
                allMakes.map((vehicle, index) => {
                  return (
                    <option key={index} value={vehicle}>
                      {vehicle}
                    </option>
                  )
                })
              ) : (
                <option />
              )}
            </Field>
          </div>
          <div>
            <h2 className="filter__header">Model</h2>
            <hr className="form__hr vehicle-filter__hr" />
            <Field
              label="Select a model"
              name="model"
              component={SelectField}
              gridClass="field vehicle-filter__field"
              disabled={makesData ? false : true}
            >
              <option value="" />
              {vehicleMakes.models ? (
                vehicleMakes.models.map((vehicle, index) => {
                  return (
                    <option key={index} value={vehicle}>
                      {vehicle}
                    </option>
                  )
                })
              ) : (
                <option />
              )}
            </Field>
          </div>
          <div>
            <h2 className="filter__header">State</h2>
            <hr className="form__hr vehicle-filter__hr" />
            <Field
              label="Select a state"
              name="plateState"
              component={SelectField}
              gridClass="field vehicle-filter__field"
            >
              <option value="">No state selected</option>
              <option value="AL">Alabama</option>
              <option value="AK">Alaska</option>
              <option value="AZ">Arizona</option>
              <option value="AR">Arkansas</option>
              <option value="CA">California</option>
              <option value="CO">Colorado</option>
              <option value="CT">Connecticut</option>
              <option value="DE">Delaware</option>
              <option value="FL">Florida</option>
              <option value="GA">Georgia</option>
              <option value="HI">Hawaii</option>
              <option value="ID">Idaho</option>
              <option value="IL">Illinois</option>
              <option value="IN">Indiana</option>
              <option value="IA">Iowa</option>
              <option value="KS">Kansas</option>
              <option value="KY">Kentucky</option>
              <option value="LA">Louisiana</option>
              <option value="ME">Maine</option>
              <option value="MD">Maryland</option>
              <option value="MA">Massachusetts</option>
              <option value="MI">Michigan</option>
              <option value="MN">Minnesota</option>
              <option value="MS">Mississippi</option>
              <option value="MO">Missouri</option>
              <option value="MT">Montana</option>
              <option value="NE">Nebraska</option>
              <option value="NV">Nevada</option>
              <option value="NH">New Hampshire</option>
              <option value="NJ">New Jersey</option>
              <option value="NM">New Mexico</option>
              <option value="NY">New York</option>
              <option value="NC">North Carolina</option>
              <option value="ND">North Dakota</option>
              <option value="OH">Ohio</option>
              <option value="OK">Oklahoma</option>
              <option value="OR">Oregon</option>
              <option value="PA">Pennsylvania</option>
              <option value="RI">Rhode Island</option>
              <option value="SC">South Carolina</option>
              <option value="SD">South Dakota</option>
              <option value="TN">Tennessee</option>
              <option value="TX">Texas</option>
              <option value="UT">Utah</option>
              <option value="VT">Vermont</option>
              <option value="VA">Virginia</option>
              <option value="WA">Washington</option>
              <option value="WV">West Virginia</option>
              <option value="WI">Wisconsin</option>
              <option value="WY">Wyoming</option>
            </Field>
          </div>
          <div>
            <h2 className="filter__header">Financeable</h2>
            <hr className="form__hr vehicle-filter__hr" />
            <label className="form__label">Is the car financeable?</label>
            <br />
            <RadiobuttonGroup name="financeable" value="TRUE" label="Yes" />
            <RadiobuttonGroup name="financeable" value="FALSE" label="No" />
          </div>
          <div>
            <h2 className="filter__header">Ownership</h2>
            <hr className="form__hr vehicle-filter__hr" />
            <Field
              label="Select an ownership status"
              name="ownershipVerification"
              component={SelectField}
              gridClass="field vehicle-filter__field"
            >
              <option value="">None</option>
              <option value="VERIFIED">Verified</option>
              <option value="EXPIRED">Expired</option>
              <option value="REJECTED">Rejected</option>
            </Field>
          </div>
          <div>
            <h2 className="filter__header">Organizations</h2>
            <hr className="form__hr filter__hr" />
            <AccessibleOrganizationsSelect
              label="Select organizations"
              name="organizations"
            />
          </div>
          <div className="form__group vehicle-filter__buttons">
            <LoaderButton
              type="submit"
              className="button button--primary vehicle-filter__button--apply"
              isLoading={submitting}
            >
              Apply
            </LoaderButton>
            <a
              onClick={clear}
              className="button button--secondary vehicle-filter__button--reset"
              aria-label="Clear"
            >
              Clear
            </a>
          </div>
          <a
            onClick={cancel}
            className="button button-link-text vehicle-filter__cancel"
          >
            Cancel
          </a>
        </div>
      </form>
    )
  }
}

let FilterForm = reduxForm<object, Props>({
  form: 'vehicleFilterForm',
  enableReinitialize: false,
  destroyOnUnmount: true,
})(VehicleFilterForm)

const selector = formValueSelector('vehicleFilterForm')

let ConnectedFilterForm = connect(
  (state: { allMakesModels: object }) => {
    const makesData = selector(state, 'make')
    return {
      makesData,
      allMakes: selectAllVehicleMakes(state.allMakesModels),
      allModels: selectAllVehicleModels(state.allMakesModels),
    }
  },
  { fetchAllVehicles }
)(FilterForm)

export default ConnectedFilterForm
